"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import { useNavigate } from "react-router-dom";
import SectionTitle from "@/components/common/section-title";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Classements, marques et labels"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <p className={"text-justify text-normal my-4"}>
                    Qualifier votre offre est une action essentielle, cela vous permet d’obtenir un regard d’expert, de
                    bénéficier de services, de vous positionner et c’est avant tout un gage de qualité pour le visiteur.
                    Il est important d’adhérer au programme <strong>AKWABA SAFELY™</strong>.
                </p>

                <SectionTitle title={"Les bonnes raisons d’obtenir une qualification :"} variant="playfairDisplay" />

                <p className={"text-justify text-normal my-4 mb-8"}>
                    Qualifier votre offre est une action essentielle, cela vous permet d’obtenir un regard d’expert, de
                    bénéficier de services, de vous positionner et c’est avant tout un gage de qualité pour le visiteur.
                    Il est important d’adhérer au programme <strong>AKWABA SAFELY™</strong>.
                </p>

                <SectionTitle title={"Le classement des hébergements touristiques"} variant="playfairDisplay"/>

                <p className={"text-justify text-normal my-4"}>
                    Le classement fait par le Fonds de Développement Touristique est obligatoire et il est évalué tous
                    les 5 ans par un organisme de contrôle accrédité. Pour donner des repères fiables aux clientèles
                    touristiques, les hébergements bénéficient d’un classement de 1 à 5 étoiles.
                    <br/>
                    Le classement est établi selon 3 grands axes :
                </p>

                <ul className="text-normal list-disc list-inside">
                    <li className="li1">Le degré de confort</li>
                    <li className="li1">Les services</li>
                    <li className="li1">Les bonnes pratiques en matière de respect de
                        l’environnement et l’accueil des personnes en situation de handicap.
                    </li>
                </ul>
                <p className="text-normal">Consulter la fiche technique – classification des hébergements (actif)</p>

                <SectionTitle title={"Le référencement des chambres d'hôtes"} variant="playfairDisplay" className={"mt-8"}/>

                <p className="text-normal mb-8 mt-4">
                    Il n’existe pas en COTE D’IVOIRE de classement pour les chambres d’hôtes. Pour pallier ce manque et
                    pour répondre aux attentes des propriétaires d’hébergements non labellisés, l’Office de Tourisme a
                    mis en place une qualification nationale appelée Chambre d’hôtes Tourisme basée sur un référentiel
                    unique.
                    <br/>
                    La qualification Chambre d’hôtes Tourisme est une reconnaissance, pour une durée de 5 ans, de la
                    qualité de vos chambres d’hôtes, qui vous permettra de garantir à votre clientèle l’assurance d’être
                    bien accueillie selon les critères de légalité, de confort et de services du référentiel.
                </p>

                <SectionTitle title={"Les marques"} variant="playfairDisplay" className={"mt-8"}/>

                <p className="text-normal mb-8 mt-4">
                    <h4 className={"font-roboto font-black"}>Mise en place d’outils de la qualité</h4>
                    La marque <strong>AKWABA SAFELY™</strong> est la marque de COTE D’IVOIRE TOURISME de qualité
                    tourisme sur laquelle nous avons travaillé afin de l’attribuer aux socio-professionnels du tourisme
                    pour la qualité de leur accueil et de leurs prestations.
                </p>

                <div className={"flex justify-center"}>
                    <img src={"/images/AKWABA-Safely.png"} alt={"Marque akwaba safely"} width={1000} height={1000}
                           className={"w-48"}/>
                </div>

                <p className="text-normal mt-4">
                    Pour obtenir la marque, le prestataire doit suivre avec succès une démarche qualité conforme aux
                    exigences essentielles à votre satisfaction. Gage de confiance, les prestations sont régulièrement
                    soumises à un contrôle inopiné et indépendant. Ce signe de reconnaissance permettra au client de
                    choisir en toute confiance des établissements touristiques qui offrent des prestations de qualité.
                    <br/>
                    <strong>AKWABA SAFELY™</strong> s’adresse à toute la chaine de valeur et d’accueil touristique et
                    accompagne le client tout au long de son séjour : hébergements, restauration, lieux de visite,
                    activités sportives et de loisirs, offices de tourisme…
                    <br/>
                    <br/>
                    Le voyageur pourra programmer ses vacances en toute sérénité.
                    <br/>
                    <br/>
                    Pour obtenir la Marque <strong>AKWABA SAFELY™</strong>, un établissement candidat doit répondre aux
                    exigences suivantes :
                </p>

                <ul className="text-normal mb-8 list-disc list-inside">
                    <li className="li1"><b>Un accueil chaleureux</b></li>
                    <li className="li1">Un personnel attentif</li>
                    <li className="li1">La maîtrise des langues étrangères</li>
                    <li className="li1">Des prestations personnalisées</li>
                    <li className="li1">Des informations claires et précises</li>
                    <li className="li1">Une propreté et un confort assurés</li>
                    <li className="li1">Mise en place et respect des règles HACCP</li>
                    <li className="li1">La découverte d’une destination</li>
                    <li className="li1">La prise en compte de votre avis</li>
                    <li className="li1"><b>Être classé</b> (Hôtels, Résidences, Restaurant, Maquis etc.)</li>
                    <li className="li1"><b>Mettre en place un processus de gestion de la relation client et de la
                        satisfaction client </b></li>
                </ul>

                <p className="text-normal mb-8 mt-4">
                    La Marque <strong>AKWABA SAFELY™</strong>, sera attribuée aux professionnels du tourisme pour la qualité de leur accueil et de leurs prestations
                </p>
            </SectionPage>

        </div>
    );
}
